// extracted by mini-css-extract-plugin
export default {"page__nav":"Page404_page__nav__Engdo","page__main":"Page404_page__main__XYYGZ","page__text":"Page404_page__text__Kl9aO"};